import { motion } from "framer-motion";
import MachineMockup from "./MachineMockup";

const AREAS = [
  { testid: "passport-area-info", num: "01", title: "Información", text: "Fabricante, modelo, número de serie, año, ubicación y estado." },
  { testid: "passport-area-docs", num: "02", title: "Documentos", text: "Manuales, esquemas eléctricos, fichas técnicas, certificados y documentación." },
  { testid: "passport-area-photos", num: "03", title: "Fotografías", text: "Máquina, placa de características, componentes, averías, reparaciones e instalación." },
  { testid: "passport-area-history", num: "04", title: "Historial", text: "Mantenimientos, averías, reparaciones, inspecciones, modificaciones y notas." },
];

export default function PassportSection() {
  return (
    <section id="producto" className="scroll-mt-20" data-testid="pasaporte-digital-demo">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-5">El pasaporte digital</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
            Cada máquina tiene su propio pasaporte.
          </h2>
          <p className="text-lg sm:text-xl text-zinc-600 leading-relaxed mt-5">
            Todo lo importante. En un único lugar.
          </p>
        </div>

        <div className="grid lg:grid-cols-[minmax(0,5fr),minmax(0,6fr)] gap-14 lg:gap-20 items-center mt-16 lg:mt-24">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
          >
            <MachineMockup testid="pasaporte-demo-mockup" testidPrefix="demo-" />
          </motion.div>

          <div className="space-y-2">
            {AREAS.map((a, i) => (
              <motion.div
                key={a.testid}
                data-testid={a.testid}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="group flex gap-6 py-6 border-b border-zinc-100 last:border-0"
              >
                <span className="font-heading text-sm font-semibold text-zinc-300 group-hover:text-zinc-900 transition-colors pt-1">
                  {a.num}
                </span>
                <div>
                  <h3 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-zinc-900">
                    {a.title}
                  </h3>
                  <p className="text-base text-zinc-600 leading-relaxed mt-1.5">{a.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
